import React, { PropsWithChildren } from 'react';
import { Paper, SxProps, Theme } from '@mui/material';
import { create } from 'zustand';

export const statsPushDown = create(() => 0);

export function StandardFloatingBox(props: PropsWithChildren<{ sx?: SxProps<Theme>; className?: string }>) {
  return (
    <Paper
      elevation={0}
      className={props.className}
      sx={[
        {
          padding: 1,
          minWidth: 80,
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      {props.children}
    </Paper>
  );
}
